import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomizerService } from './common/services/customizer.service';
import { NavService } from './common/services/nav.service';
import { User } from './auth/user';
import { AuthenticationService } from './auth/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

    public systemCode: string;
    public userSelectedLang: string;
    public controller: string;
    public action: string;
    public systemFooter: string;
    public version: string;
    public insurancedXPortal: string = "false";
    public right_side_bar: boolean;
    currentUser: User;

    constructor(private translate: TranslateService,
                public navServices: NavService,
                public customizer: CustomizerService,
                public authService: AuthenticationService) {
        this.authService.currentUser.subscribe(x => this.currentUser = x);
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};
        if (browserWindowEnv.hasOwnProperty('userSelectedLang')) {
            this.userSelectedLang = window['__env']['userSelectedLang'];
            translate.setDefaultLang(this.userSelectedLang);
            this.translate.use(this.userSelectedLang);
            if (this.userSelectedLang == "ar") {
                this.customizer.setLayoutType("rtl");
            }
            else {
                this.customizer.setLayoutType("ltr");
            }
        }

        if (browserWindowEnv.hasOwnProperty('insurancedXPortal')) {
            this.insurancedXPortal = window['__env']['insurancedXPortal'];
        }

        if (browserWindowEnv.hasOwnProperty('systemCode')) {
            this.systemCode = window['__env']['systemCode'];
        }

        if (browserWindowEnv.hasOwnProperty('controller')) {
            this.controller = window['__env']['controller'];
        }

        if (browserWindowEnv.hasOwnProperty('action')) {
            this.action = window['__env']['action'];
        }

        if (browserWindowEnv.hasOwnProperty('systemFooter')) {
            this.systemFooter = window['__env']['systemFooter'];
        }

        if (browserWindowEnv.hasOwnProperty('version')) {
            this.version = window['__env']['version'];
        }
    }

    public getRouterOutletState(outlet) {
        return outlet.isActivated ? outlet.activatedRoute : '';
    }

    public rightSidebar($event) {
        this.right_side_bar = $event
    }

  title = 'gisApp';
}
